/* eslint-disable react/require-default-props */
import React from 'react'

import {
  SpecialVideoPropTypes
} from 'components/SpecialVideos/SpecialVideoDetail'

import './styles.css'

function SpecialVideoCurriculum({ chapters = '' }) {
  return (
    <div className="SpecialVideoChapters">
      <ol>
        {chapters.split('\r\n\r\n').map((chapter, chapterIndex) => (
          <li key={chapterIndex}>
            <span className="chapter">{chapter}</span>
          </li>
        ))}
      </ol>
    </div>
  )
}

SpecialVideoCurriculum.propTypes = SpecialVideoPropTypes

export default SpecialVideoCurriculum
